import React from "react";
import CountUp from "react-countup";
import { useNavigate } from "react-router-dom";

const Spaghetti = () => {
    const navigate = useNavigate();
    return (
        <div >
            <div className="indicator-container">
                <div className="indicator ">

                </div>
                <div className="indicator selected">

                </div>
                <div className="indicator">

                </div>
                <div className="indicator">

                </div>
                <div className="indicator">

                </div>
                <div className="indicator">

                </div>
            </div>

            <div style={{
                marginTop: '2vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'

            }}>
                <img className="vivify popIn" src="/assets/sp.png" alt="dad" />
                <img className="vivify fadeIn delay-500" style={{ margin: 'auto', width: 'fit-content' }} src="/assets/sp1.png" alt="dad" />
                <h1 className="large-text">You Made Spaghetti&nbsp;<CountUp end={37} duration={6} />&nbsp;Times This Year</h1>
                <div className="large-button-container">
                    <button onClick={
                        () => {
                            navigate('/dad/travel');
                        }
                    } className="large-button">
                        Let's Continue
                    </button>
                </div>
            </div>

        </div>
    );
}

export default Spaghetti;